import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import WaLink, { eyebrow } from './WaLink';
import { services } from '../data/salon';

const serviceImages = {
  'Bridal Makeup': 'https://media-manager-c.questera.ai/greta-media/328ccc7bfb8464cff28181f04d7e316c687ae1ee10dbf54c15208ba3627bd0db1bd72f93a9d5ca38120edb70dfec833b/images/aW1hZ2Uvd2VicA==/8e25d85374e27bef66c40109d44f35e5.webp',
  'Party Makeup': 'https://media-manager-c.questera.ai/greta-media/328ccc7bfb8464cff28181f04d7e316c687ae1ee10dbf54c15208ba3627bd0db1bd72f93a9d5ca38120edb70dfec833b/images/aW1hZ2Uvd2VicA==/683317411f82af215dae9ef222ec9f2f.webp',
  'Hair Styling': 'https://media-manager-c.questera.ai/greta-media/328ccc7bfb8464cff28181f04d7e316c687ae1ee10dbf54c15208ba3627bd0db1bd72f93a9d5ca38120edb70dfec833b/images/aW1hZ2Uvd2VicA==/80f72f3d29b6377f387e16946e007a45.webp',
  'Hair Colouring': 'https://media-manager-c.questera.ai/greta-media/328ccc7bfb8464cff28181f04d7e316c687ae1ee10dbf54c15208ba3627bd0db1bd72f93a9d5ca38120edb70dfec833b/images/aW1hZ2Uvd2VicA==/d40ee7f5cc4f29ca09626ec5c9d247a9.webp',
  Facials: 'https://media-manager-c.questera.ai/greta-media/328ccc7bfb8464cff28181f04d7e316c687ae1ee10dbf54c15208ba3627bd0db1bd72f93a9d5ca38120edb70dfec833b/images/aW1hZ2Uvd2VicA==/dfb2b7ff9c562ac50cd5ffc72a33aece.webp',
  Skincare: 'https://media-manager-c.questera.ai/greta-media/328ccc7bfb8464cff28181f04d7e316c687ae1ee10dbf54c15208ba3627bd0db1bd72f93a9d5ca38120edb70dfec833b/images/aW1hZ2Uvd2VicA==/5eba9787438952da2c784e8e0f403113.webp',
  Waxing: 'https://media-manager-c.questera.ai/greta-media/328ccc7bfb8464cff28181f04d7e316c687ae1ee10dbf54c15208ba3627bd0db1bd72f93a9d5ca38120edb70dfec833b/images/aW1hZ2Uvd2VicA==/25362f6790642a2ab9f995554f13063c.webp',
  Manicure: 'https://media-manager-c.questera.ai/greta-media/328ccc7bfb8464cff28181f04d7e316c687ae1ee10dbf54c15208ba3627bd0db1bd72f93a9d5ca38120edb70dfec833b/images/aW1hZ2Uvd2VicA==/c09f8f71ad45fd0ba813355b132213aa.webp',
  Pedicure: 'https://media-manager-c.questera.ai/greta-media/328ccc7bfb8464cff28181f04d7e316c687ae1ee10dbf54c15208ba3627bd0db1bd72f93a9d5ca38120edb70dfec833b/images/aW1hZ2Uvd2VicA==/b7e5aacd33f1598501697b9f43c08ea2.webp',
};

function Services() {
  return (
    <section id="services" className="bg-[#E4EDE6] py-20">
      <div className="mx-auto max-w-[1280px] px-4 sm:px-6">
        <div className="mb-10 max-w-xl">
          <span className={eyebrow}>Our beauty services</span>
          <h2 className="font-display mt-3 text-4xl text-[#0B3B36] sm:text-5xl">
            Pick your <em className="text-[#C8553D]">ritual.</em>
          </h2>
        </div>
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {services.map((service, index) => (
            <WaLink
              key={service.name}
              aria-label={`Enquire about ${service.name}`}
              className="group flex items-center gap-4 rounded-2xl bg-white p-3 shadow-sm transition hover:-translate-y-1 hover:shadow-xl"
            >
              <img
                src={serviceImages[service.name] || service.image}
                alt={service.name}
                className="h-24 w-24 shrink-0 rounded-xl object-cover sm:h-28 sm:w-28"
              />
              <div className="min-w-0 flex-1">
                <span className="text-xs font-bold text-[#E9A23B]">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <h3 className="font-display text-xl text-[#0B3B36]">
                  {service.name}
                </h3>
              </div>
              <span className="mr-2 grid h-10 w-10 shrink-0 place-items-center rounded-full bg-[#0B3B36] text-[#E9A23B] transition group-hover:rotate-45">
                <SafeIcon icon={FiIcons.FiArrowUpRight} />
              </span>
            </WaLink>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
